import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import ResourceFormButton from "../components/ResourceFormButton";
import LDAPTestButton from "../components/LDAPTestButton";
import DeleteResourceButton from "../components/DeleteResourceButton";
import { Renderer } from "./common";
import { defineMessage, defineMessages, FormattedMessage } from "react-intl";

const directoryTypesTranslations = defineMessages({
    ACTIVEDIRECTORY: {
        id: "ldap_auth.directory_types.ACTIVEDIRECTORY",
        defaultMessage: "Microsoft Active Directory",
    },
    OPENLDAP: {
        id: "ldap_auth.directory_types.OPENLDAP",
        defaultMessage: "OpenLDAP",
    },
});

const ldapAuthRenderers: Record<string, Renderer> = {
    use_ssl: (val, _data) => {
        // jscs:ignore requireCamelCaseOrUpperCaseIdentifiers
        const icon = val ? (
            <FontAwesomeIcon icon={faCheck} color="green" />
        ) : (
            <FontAwesomeIcon icon={faTimes} color="red" />
        );
        return icon;
    },
    directory_type: (val, _data) => {
        return <FormattedMessage {...directoryTypesTranslations[val]} />;
    },
    controlHeaderCell: (val, data) => {
        return (
            <div>
                <ResourceFormButton
                    resourceName="ldap_auth"
                    action="update"
                    dialogTitle={defineMessage({
                        id: "ldap_auth.update",
                        defaultMessage: "Update LDAP server config",
                    })}
                    id={data.id}
                    size="medium"
                    buttonType="icon"
                    extraButtons={[LDAPTestButton]}
                />{" "}
                <DeleteResourceButton id={data.id} resourceName="ldap_auth" />
            </div>
        );
    },
};

export default ldapAuthRenderers;
